import axios from 'axios'
import {getAuthToken} from "../services/LocalStorageServices";
import {notify} from "./Notifications";
import {texts} from "../Languages/Language";

const BASE_URL = process.env.REACT_APP_BACKEND_URL

export const backendRequest = axios.create({
    baseURL: BASE_URL,
});

backendRequest.interceptors.request.use(config => {
        config.headers.Authorization = getAuthToken();
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

backendRequest.interceptors.response.use(response => {
        return response
    },
    error => {
    switch (error.response.status) {
        case 401:
            window.location.href = "/";
            localStorage.clear();
            break;
        case 500:
            notify("error", texts.GENERAL.ERROR_500_MESSAGE);
            break;
        default:
            return Promise.reject(error)
    }


    }
);

export const userAuthRequests = axios.create({
    baseURL: BASE_URL
});

export const pdfRequest = axios.create({
    baseURL: BASE_URL,
    method: 'GET',
    responseType: 'blob', // important
});

pdfRequest.interceptors.request.use(config => {
        config.headers.Authorization = getAuthToken();
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

pdfRequest.interceptors.response.use(response => {
        return response
    },
    error => {
        if (error.response.status === 401) {
            window.location.href = "/";
            localStorage.clear();
        }
        return Promise.reject(error)
    }
);

